function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:none;stroke:#9d9d9a;stroke-linecap:round;stroke-linejoin:round;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("polyline", {
  className: "cls-1",
  points: "6.98 18.15 0.59 9.38 6.98 0.62"
});

var SvgFlecheprev = function SvgFlecheprev(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    viewBox: "0 0 7.56 18.68",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFlecheprev, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flecheprev.c3a8dc7f.svg";
export { ForwardRef as ReactComponent };